import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { services } from "@/components/landing/data";

function ServiceCard({ service, index }) {
  const setSpotlight = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    event.currentTarget.style.setProperty("--spot-x", `${event.clientX - rect.left}px`);
    event.currentTarget.style.setProperty("--spot-y", `${event.clientY - rect.top}px`);
  };

  return (
    <motion.article
      data-testid={`service-card-${index + 1}`}
      onMouseMove={setSpotlight}
      initial={{ opacity: 0, y: 42 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.75, delay: index * 0.08, ease: [0.16, 1, 0.3, 1] }}
      className="spotlight-card group overflow-hidden rounded-[1.6rem] border border-white/10 bg-[#0F0F17]"
    >
      <div className="relative h-64 overflow-hidden" style={{ clipPath: index % 2 ? "polygon(0 0, 100% 5%, 96% 100%, 0 94%)" : "polygon(4% 0, 100% 0, 100% 95%, 0 100%)" }}>
        <img src={service.image} alt={`${service.title} visual`} data-testid={`service-image-${index + 1}`} loading="lazy" className="h-full w-full object-cover opacity-75 transition duration-700 group-hover:scale-105 group-hover:opacity-95" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#08080C] via-transparent to-transparent" />
        <span className="absolute left-5 top-5 rounded-full bg-black/60 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-cyan-200 backdrop-blur-md">{service.label}</span>
      </div>
      <div className="p-7 sm:p-8">
        <div className="mb-5 flex items-start justify-between gap-4">
          <h3 className="font-display text-2xl font-bold uppercase tracking-[-0.03em] text-white">{service.title}</h3>
          <ArrowUpRight className="mt-1 h-5 w-5 text-cyan-300 transition-transform group-hover:-translate-y-1 group-hover:translate-x-1" />
        </div>
        <p className="text-sm leading-relaxed text-slate-400 sm:text-base">{service.text}</p>
      </div>
    </motion.article>
  );
}

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="section-shell py-24 sm:py-32">
      <div className="mb-14 flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
        <div>
          <p data-testid="services-eyebrow" className="eyebrow">Capabilities / deliverables</p>
          <h2 data-testid="services-heading" className="mt-4 max-w-3xl font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-[-0.05em] text-white sm:text-6xl">Built like a product. Finished like art.</h2>
        </div>
        <p data-testid="services-description" className="max-w-md text-sm leading-relaxed text-slate-400 sm:text-base">Every engagement is designed around your customers, your market, and the action you need visitors to take.</p>
      </div>
      <div className="grid gap-6 md:grid-cols-2">{services.map((service, index) => <ServiceCard key={service.title} service={service} index={index} />)}</div>
    </section>
  );
}
